import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SuccessDialogService } from '../../_services/success-dialog.service';
import { SessionActivityDataForm } from '../../_models/session-activity-data-form';
import { MatStepper } from '@angular/material';
import { SesssionActivityService } from '../../_services/sesssion-activity.service';
import { UserSessionDataForm } from '../../_models/login/user-session-data-form';
import { Router } from '@angular/router';
import { NavbarService } from '../../_services/navbar.service';
import { TestResultsService } from '../../_services/test-results.service';

@Component({
  selector: 'app-learning-draft',
  templateUrl: './learning-draft.component.html',
  styleUrls: ['./learning-draft.component.css']
})
export class LearningDraftComponent implements OnInit {
  // @Input('matTooltip') message: string;
  @ViewChild('stepper') stepper: MatStepper;


  message: string;

  navItemSelected: string = '';
  learningTitle: string = '';
  userDataSession;
  userDetailsId = 0;
  stepperIndex: number;
  lastSessionActivityNumber: number;
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm();
  sessionActivity;
  userTestResults;

  constructor(private router: Router,
    private sesssionActivityService: SesssionActivityService,
    private successDialogService: SuccessDialogService,
    private navbarService: NavbarService,
    private testResultsService: TestResultsService
  ) {

  }

  ngOnInit() {
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userDetailsId = this.userDataSession.userDetailsId;
    }
    this.getLastSessionAcgtivityBYUserId(this.userDetailsId, 4);
    this.getUserTestResults(this.userDetailsId, 3)
  }

  getUserTestResults(userId, testType) {
    this.testResultsService.getUserTestResults(userId, testType).subscribe(
      resp => {
        this.userTestResults = resp;
      }, error => {
        console.log(error);
      })
  }

  getStepperIndexVaule(value) {
    switch (value) {
      case 1:
        this.message = " Patent draft and it's types";
        break;
      case 2:
        this.message = " Ordinary applications";
        break;
      case 3:
        this.message = "Conventional & PCT applications";
        break;
      case 4:
        this.message = "Advantages of filing a PCT application";
        break;
      case 5:
        this.message = "Patent of addition & Divisional application";
        break;
      case 6:
        this.message = "Standard format for patent draft";
        break;
      case 7:
        this.message = "Title & field of the invention";
        break;
      case 8:
        this.message = "Problem and solution";
        break;
      case 9:
        this.message = "Detailed explanation regarding the invention";
        break;
      case 10:
        this.message = " Abstract";
        break;
      case 11:
        this.message = " Claim & its types";
        break;
      case 12:
        this.message = "Points should be considered while drafting patent claims";
        break;
      case 13:
        this.message = "Tips on drafting claims";
        break;
      default:
        break;
    }
  }

  getLastSessionAcgtivityBYUserId(userDetailId, activityType) {
    this.sesssionActivityService.getLastSessionActiityByUserId(userDetailId, activityType).subscribe(
      resp => {
        this.sessionActivity = resp;
        if (this.sessionActivity == null) {
        } else {
          this.lastSessionActivityNumber = this.sessionActivity.lastActivitySession - 1;
          this.stepper._stepHeader.forEach(
            step => {
              if (step.index <= this.lastSessionActivityNumber) {
                setTimeout(() => {
                  this.stepper.selectedIndex = step.index;
                });
              }
            })
        }
      }, error => {
        console.log(error);
      })
  }

  isSeenFirst = false;
  isSeenSecond = false;
  isSeenThird = false;
  isSeenFour = false;
  isSeenFive = false;
  isSeenSix = false;
  isSeenSeven = false;
  isSeenEight = false;
  isSeenNine = false;
  isSeenTen = false;
  isSeenEleven = false;
  isSeenTwelve = false;
  isSeenThirteen = false;
  isSeenFourteen = false;
  moveNextIndex() {

    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.activityType = 4
    const currentUser = localStorage.getItem('currentUser');
    this.sessionActivityDataForm.userDetails = JSON.parse(currentUser);
    switch (indexNumber) {
      case (2):
        if (!this.isSeenSecond) {
          this.isSeenSecond = true;
          this.sessionActivityDataForm.lastActivitySession = 2;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (3):
        if (!this.isSeenThird) {
          this.isSeenThird = true;
          this.sessionActivityDataForm.lastActivitySession = 3;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (4):
        if (!this.isSeenFour) {
          this.isSeenFour = true;
          this.sessionActivityDataForm.lastActivitySession = 4;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (5):
        if (!this.isSeenFive) {
          this.isSeenFive = true;
          this.sessionActivityDataForm.lastActivitySession = 5;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (6):
        if (!this.isSeenSix) {
          this.isSeenSix = true;
          this.sessionActivityDataForm.lastActivitySession = 6;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (7):
        if (!this.isSeenSeven) {
          this.isSeenSeven = true;
          this.sessionActivityDataForm.lastActivitySession = 7;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (8):
        if (!this.isSeenEight) {
          this.isSeenEight = true;
          this.sessionActivityDataForm.lastActivitySession = 8;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (9):
        if (!this.isSeenNine) {
          this.isSeenNine = true;
          this.sessionActivityDataForm.lastActivitySession = 9;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (10):
        if (!this.isSeenTen) {
          this.isSeenTen = true;
          this.sessionActivityDataForm.lastActivitySession = 10;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (11):
        if (!this.isSeenEleven) {
          this.isSeenEleven = true;
          this.sessionActivityDataForm.lastActivitySession = 11;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (12):
        if (!this.isSeenTwelve) {
          this.isSeenTwelve = true;
          this.sessionActivityDataForm.lastActivitySession = 12;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (13):
        if (!this.isSeenThirteen) {
          this.isSeenThirteen = true;
          this.sessionActivityDataForm.lastActivitySession = 13;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      default:
        break;
    }
  }

  // ===== Success Dialog =====
  moveToPatentDraftTest() {
    if (this.userTestResults == null) {
      this.navbarService.saveActiveNavItem('Patent Drafting Quiz')
      this.successDialogService.successDialog(4);
    } else {
      this.navbarService.saveActiveNavItem('Patent Filing')
      this.router.navigate(['/main/learning/learnPatentFiling']);
    }
  }
  
}
